// Přepínač kolekce (drobečky, nadpis kolekce): tlačítko .ai-bc-toggle otevírá menu svého obalu
// [data-bc-switch]; klik mimo nebo Esc zavře všechna.
(function () {
  if (window.aiBcBound) return;
  window.aiBcBound = true;
  var mobil = window.matchMedia('(max-width: 749px)');
  // Mobil: bublina Poradny (Notia Advisor) by ležela přes spodek panelu – dokud je panel otevřený,
  // schová se veřejnou třídou appky. Odebere ji jen tenhle skript, pokud ji přidal (stejnou třídu
  // nastavuje i lepicí lišta na detailu produktu, assets/buybox-sticky.js).
  var skrytaPoradna = false;
  function poradna() {
    var schovat = mobil.matches && !!document.querySelector('[data-bc-switch].open');
    var body = document.body;
    if (schovat && !skrytaPoradna && !body.classList.contains('notia-advisor-hide-launcher')) {
      body.classList.add('notia-advisor-hide-launcher');
      skrytaPoradna = true;
    } else if (!schovat && skrytaPoradna) {
      // Lišta se mezitím mohla ukázat (ml-lista) – pak bublinu dál drží schovanou ona.
      if (!body.classList.contains('ml-lista')) body.classList.remove('notia-advisor-hide-launcher');
      skrytaPoradna = false;
    }
  }
  function closeAll(except) {
    document.querySelectorAll('[data-bc-switch].open').forEach(function (s) {
      if (s === except) return;
      s.classList.remove('open');
      var b = s.querySelector('.ai-bc-toggle');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    poradna();
  }
  // Mobil: menu je spodní panel nad ztmavenou stránkou – ťuknutí mimo panel ho jen zavře,
  // neproklikne se na odkaz pod ztmavením (zachyceno dřív, než se k odkazu dostane).
  document.addEventListener('click', function (e) {
    var open = document.querySelector('[data-bc-switch].open');
    if (!open || !mobil.matches || open.contains(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    closeAll(null);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.ai-bc-toggle') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var s = btn.closest('[data-bc-switch]');
      var willOpen = !s.classList.contains('open');
      closeAll(s);
      s.classList.toggle('open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      poradna();
      return;
    }
    closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
